import { load, initDeployments, abort, getActive } from './app';

const Pastease = {
	load,
	forceParse: initDeployments,
	abort,
	getActive,
};

window.Pastease = Pastease;
window.mopinionDeploy = Pastease;

export default Pastease;
